export default __webpack_public_path__ + "static/media/location.87f1d0ea.svg";